import { render, staticRenderFns } from "./JdsAnalyticsProvider.vue?vue&type=template&id=54445801&scoped=true&"
import script from "./JdsAnalyticsProvider.vue?vue&type=script&lang=ts&"
export * from "./JdsAnalyticsProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54445801",
  null
  
)

export default component.exports